import { Params } from '@angular/router';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Post } from '@planone/bau365/util-fair-data';
import { selectRouteParams } from '@planone/shared/util-ngrx';

import { DATA_ACCESS_POSTS_FEATURE_KEY, PostsState } from './data-access-posts.reducer';

import { getExhibitorId } from '../../exhibitors/entity/data-access-exhibitors.selectors';

export const getDataAccessPostsState = createFeatureSelector<PostsState>(DATA_ACCESS_POSTS_FEATURE_KEY);

export const getPostId = createSelector(selectRouteParams, (routerParams: Params) => {
  return typeof routerParams !== 'undefined' && routerParams['id'] != null ? routerParams['id'] : undefined;
});

export const getPostById = createSelector(getDataAccessPostsState, (state: PostsState, props: { postId?: string }) => {
  if (props.postId && state.posts && state.posts[props.postId]) {
    return state.posts[props.postId];
  }

  return undefined;
});

export const getPost = createSelector(getDataAccessPostsState, getPostId, (state: PostsState, postId: string) =>
  postId != null ? state.posts[postId] : undefined
);
export const getActivePostLoading = createSelector(
  getDataAccessPostsState,
  (state: PostsState) => state.activePostLoading
);
export const getActivePostError = createSelector(getDataAccessPostsState, (state: PostsState) =>
  state.activePostError ? state.activePostError : undefined
);

export const getPostExhibitorPosts = createSelector(
  getDataAccessPostsState,
  getExhibitorId,
  (state: PostsState, exhibitorId: string) =>
    Object.values(state.posts).filter((post) => post.exhibitor_id === exhibitorId)
);

export const getPostPosts = createSelector(getDataAccessPostsState, getPost, (state: PostsState, openedPost?: Post) =>
  Object.values(state.posts).filter(
    (post) => post.exhibitor_id === openedPost?.exhibitor_id && post.id !== openedPost?.id
  )
);
